import Modal from "react-bootstrap/Modal";
import { useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import ErrorAdd from "../../../util/ErrorAdd";

function LabelModalArchive({ show, onHide, onHideLabel, model }) {

    const [log, setLog] = useState(null);
    const [loading, setLoading] = useState(false);

    function removeHandler() {
        setLoading(true);

        axios.post('/api_tracker/label/updateStatus', { ID_Label: model.ID, ID_Status: 0 })
            .then((res) => {
                if (res.data.Status === 1) {
                    setLoading(false);
                    onHide();
                    onHideLabel();
                }
                else {
                    setLoading(false);
                    setLog(res.data.Error);
                }
            })
            .catch((err) => {
                setLog('Неизвестная ошибка!');
                setLoading(false);
                ErrorAdd(err, window.location.href);
            });
    }

    return (
        <>
            <Modal show={show} onHide={onHide}>
                <Modal.Body>
                    <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
                    <div className="modal_title text-center mb-20">Архивирование метки</div>

                    <div className="text-center mb-20">Подтвердите архивирование метки
                        <br></br>
                        <div className="badge" style={{ backgroundColor: model.Color, marginTop: "6px" }}>{model.Name}</div>
                    </div>
                    {log !== null && <div className="form_error text-center mt-15">{log}</div>}
                    <div className="row mt-15">
                        <div className="col-md-12 text-center">
                            <SrvButton typeBtn="archive" loading={loading} size={'lg'} onClick={() => removeHandler()} />
                        </div>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
}
export default LabelModalArchive;
